import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Row,
  Col,
} from 'reactstrap';
import Select from 'react-select';

const WasteReadingForm = ({
  reading,
  saving,
  onChange,
  onSave,
  errors,
  systemState,
  selectedWeatherType,
  onWeatherChange,
}) => {
  return (
    <Form>
      <Row>
        <Col xs={12}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="masterMeter" className="mr-2">
              Master Meter
            </Label>
            <Input
              type="number"
              id="masterReading"
              name="masterReading"
              value={reading.masterReading}
              onChange={onChange}
            />
            {errors.masterReading && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.masterReading}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>

      <h5 className="mt-2">Influent</h5>
      <Row>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="phIn" className="mr-2">
              pH
            </Label>
            <Input
              type="number"
              id="phIn"
              value={reading.phIn}
              onChange={onChange}
            />
            {errors.phIn && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.phIn}
              </Alert>
            )}
          </FormGroup>
        </Col>

        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="tempIn" className="mr-2">
              Temperature
            </Label>
            <Input
              type="number"
              id="tempIn"
              value={reading.tempIn}
              onChange={onChange}
            />
            {errors.tempIn && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.tempIn}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>

      <h5 className="mt-2">Effluent</h5>

      <Row>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="phOut" className="mr-2">
              pH
            </Label>
            <Input
              type="number"
              id="phOut"
              value={reading.phOut}
              onChange={onChange}
            />
            {errors.phOut && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.phOut}
              </Alert>
            )}
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="bioOxyDemand" className="mr-2">
              Biological Oxygen Demand
            </Label>
            <Input
              type="number"
              id="bioOxyDemand"
              value={reading.bioOxyDemand}
              onChange={onChange}
            />
            {errors.bioOxyDemand && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.bioOxyDemand}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="chlorineResidual" className="mr-2">
              Chlorine Residual
            </Label>
            <Input
              type="number"
              id="chlorineResidual"
              value={reading.chlorineResidual}
              onChange={onChange}
            />
            {errors.chlorineResidual && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.chlorineResidual}
              </Alert>
            )}
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="phosphorous" className="mr-2">
              Phosphorous
            </Label>
            <Input
              type="number"
              id="phosphorous"
              value={reading.phosphorous}
              onChange={onChange}
            />
            {errors.phosphorous && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.phosphorous}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="dissolvedOxygen" className="mr-2">
              Dissolved Oxygen
            </Label>
            <Input
              type="number"
              id="dissolvedOxygen"
              value={reading.dissolvedOxygen}
              onChange={onChange}
            />
            {errors.dissolvedOxygen && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.dissolvedOxygen}
              </Alert>
            )}
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="dechlorination" className="mr-2">
              De-chlorination
            </Label>
            <Input
              type="number"
              id="dechlorination"
              value={reading.dechlorination}
              onChange={onChange}
            />
            {errors.dechlorination && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.dechlorination}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="sludgeLevel" className="mr-2">
              Sludge Level
            </Label>
            <Input
              type="number"
              id="sludgeLevel"
              value={reading.sludgeLevel}
              onChange={onChange}
            />
            {errors.sludgeLevel && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.sludgeLevel}
              </Alert>
            )}
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="tempOut" className="mr-2">
              Temp Out
            </Label>
            <Input
              type="number"
              id="tempOut"
              value={reading.tempOut}
              onChange={onChange}
            />
            {errors.tempOut && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.tempOut}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="precipitation" className="mr-2">
              Precipitation
            </Label>
            <Input
              type="number"
              id="precipitation"
              value={reading.precipitation}
              onChange={onChange}
            />
            {errors.precipitation && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.precipitation}
              </Alert>
            )}
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <Label for="weather">Weather Conditions</Label>
            <Select
              name="weather"
              id="weather"
              value={selectedWeatherType}
              onChange={onWeatherChange}
              options={[
                { value: 'C', label: 'Clear' },
                { value: 'PC', label: 'Partly Cloudy' },
                { value: 'OC', label: 'Overcast' },
                { value: 'R', label: 'Rain' },
              ]}
              className="mr-2"
            />
            {errors.weather && (
              <Alert className="my-2 p-2" color={'danger'}>
                {errors.weather}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="comments" className="mr-2">
              Comments
            </Label>
            <Input
              type="textarea"
              id="comments"
              value={reading.comments}
              onChange={onChange}
            />
            {errors.comments && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.comments}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <FormGroup className="text-center mt-4">
            <Button color="primary" type="submit" onClick={onSave}>
              {saving ? 'Saving' : 'Save'}
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

WasteReadingForm.propTypes = {
  reading: PropTypes.object,
  saving: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  errors: PropTypes.object,
  systemState: PropTypes.string,
  selectedWeatherType: PropTypes.object,
  onWeatherChange: PropTypes.func,
};

export default WasteReadingForm;



// WEBPACK FOOTER //
// ./src/components/reading/waste/WasteReadingForm.js